import { TypedDocumentNode, gql } from "@apollo/client";

type TestimonialsData = {
  testimonialsBySlug: TestimonialInterface[];
};
type TestimonialsParams = {
  slug?: string;
  country?: string;
};

export const GET_TESTIMONIALS_BY_SLUG: TypedDocumentNode<TestimonialsData, TestimonialsParams> =
  gql`
    query GetTestimonialsBySlug($slug: String, $country: String) {
      testimonialsBySlug(pageSlug: $slug, countrySlug: $country) {
        id
        userName
        jobTitle
        companyName
        fiveStarRating
        avatar
        avatar_img
        comments
        facebookUrl
        linkedinUrl
        twitterUrl
        instagramUrl
        category {
          name
        }
        service {
          name
          shortName
        }
      }
    }
  `;
